


















import { Vue, Component } from 'vue-property-decorator'

interface Service {
  name: string;
  items: string[];
}

@Component
export default class Services extends Vue {
  private services: Service[] = [{
    name: 'Kundendienst',
    items: [
      'Abgasdiagnose',
      'Fahrzeugvermessung',
      'Mechanik, Reifenservice + Aufbewahrung',
      'KfZ- Elektrik & Elektronik'
    ]
  }, {
    name: 'Reparatur',
    items: [
      'Fehlerspeicherauslese & Wartung',
      'Fahrzeugdiagnose',
      'Karosserieinstandsetzung',
      'Lackschadenfreie Dellenbeseitigung'
    ]
  }, {
    name: 'Pflege',
    items: [
      'Motor & Unterbodenwäsche',
      'Fahrzeugpflege Innenraum',
      'Fahrzeugpflege Karosserie'
    ]
  }]

  private didSelect (service: Service) {
    const input = document.getElementById('subject') as HTMLInputElement
    input.value = service.name

    this.scrollToContactForm()
  }

  private scrollToContactForm () {
    const nav = document.getElementsByTagName('nav')[0]
    const form = document.getElementById('contact')

    if (nav && form) {
      window.scrollTo({
        left: 0,
        top: form.offsetTop - nav.offsetHeight,
        behavior: 'smooth'
      })
    }
  }
}
